// Nosotros.js
import React from 'react';
import { FiUsers, FiTarget, FiEye, FiAward } from 'react-icons/fi';

const clientes = [
  'Constructora Urba, C.A.',
  'Proyserv, C.A.',
];

const Nosotros = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container-page">
        <div className="text-center mb-14">
          <p className="eyebrow mb-3">Conoce nuestra empresa</p>
          <h1 className="section-title">Sobre Nosotros</h1>
        </div>

        <div className="max-w-4xl mx-auto space-y-8">
          <div className="rounded-3xl bg-slate-50 p-8 md:p-10">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-xl bg-primary text-white flex items-center justify-center">
                <FiUsers className="w-6 h-6" />
              </div>
              <h2 className="text-2xl font-semibold">¿Quiénes Somos?</h2>
            </div>
            <p className="text-justify leading-relaxed text-slate-600">
              Corporación Industrial de Occidente, C.A. es una empresa venezolana dedicada a la
              elaboración y realización de proyectos de arquitectura e ingeniería civil, eléctrica,
              mecánica, industrial y petrolera, así como al mantenimiento y servicios en el área.
              Ejecutamos construcción de plantas de procesamiento de crudo, estaciones de flujo,
              fabricación de oleoductos, gaseoductos y tanques de almacenamiento, saneamiento ambiental,
              perforación, estimulación, rehabilitación, evaluación y control de pozos, locaciones,
              movimientos de tierra, vialidad y canalizaciones. Desde 2010 acompañamos a la industria
              petrolera y de la construcción con solidez y calidad.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="rounded-3xl bg-white border border-slate-100 shadow-card p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary flex items-center justify-center">
                  <FiTarget className="w-6 h-6" />
                </div>
                <h2 className="text-xl font-semibold">Misión</h2>
              </div>
              <p className="text-justify leading-relaxed text-slate-600">
                Brindar soluciones integrales de ingeniería, construcción y servicios petroleros con
                equipos calificados y tecnología adecuada, garantizando rapidez, economía y seguridad,
                y cumpliendo las normativas de seguridad, higiene y ambiente para agregar valor a la
                productividad de nuestros clientes.
              </p>
            </div>

            <div className="rounded-3xl bg-white border border-slate-100 shadow-card p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-xl bg-primary-50 text-primary flex items-center justify-center">
                  <FiEye className="w-6 h-6" />
                </div>
                <h2 className="text-xl font-semibold">Visión</h2>
              </div>
              <p className="text-justify leading-relaxed text-slate-600">
                Posicionarnos como una empresa confiable a nivel nacional en el sector petrolero e
                industrial, reconocida por la calidad y confiabilidad de sus obras, servicios y
                suministros, contribuyendo al desarrollo de la infraestructura energética del país.
              </p>
            </div>
          </div>

          <div className="rounded-3xl bg-slate-50 p-8 md:p-10">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-xl bg-primary text-white flex items-center justify-center">
                <FiAward className="w-6 h-6" />
              </div>
              <h2 className="text-2xl font-semibold">Nuestros Clientes</h2>
            </div>
            <div className="flex flex-wrap gap-3">
              {clientes.map((cliente) => (
                <span
                  key={cliente}
                  className="inline-block rounded-full bg-white border border-slate-200 px-4 py-2 text-sm text-slate-600 shadow-sm"
                >
                  {cliente}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Nosotros;
